import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import dropdownImage from "../../../../../../assets/dropdown-image.png";
import navbarBg from "../../../../../../assets/navbar-bg.jpg";
import ColorPicker from "../../../../../../components/ColorPicker/ColorPicker";
import { useCustomisation } from "../../../../../../context/CustomisationContext";
import { usePortal } from "../../../../../../context/PortalsContext";
import { updateSectionDesign } from "../../../../../../services/api/apiClient";
import { gray } from "../../../../../../theme/themePrimitives";

interface NavbarCustomisationProps {}

export const NavbarCustomisation: React.FC<NavbarCustomisationProps> = () => {
  const { updateCustomisationSection, getCustomisationValue } =
    useCustomisation();
  const { portals } = usePortal();

  const handleAttributeChange = (
    attributeKey: string,
    newAttributeValue?: string
  ) => {
    if (!newAttributeValue) return;

    updateCustomisationSection("GPC", "navbarSettings", {
      [attributeKey]: newAttributeValue,
    });

    updateSectionDesign(
      portals.selectedPortal?.portalUid!,
      "GPC",
      "navbarSettings",
      {
        attributeKey,
        attributeValue: newAttributeValue,
      }
    );
  };

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h5" fontWeight="bold">
          Navbar
        </Typography>
      </Box>
      <Divider />
      <Stack spacing={1}>
        <Typography fontSize={"16px"} fontWeight="bold">
          Navbar background color
        </Typography>
        <Box
          sx={{
            border: `1px solid ${gray[300]}`,
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            p: 2,
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography>Navbar BG</Typography>
            <ColorPicker
              value={getCustomisationValue(
                "GPC",
                "navbarSettings",
                "navbarBgColor"
              )}
              onChange={(color) =>
                handleAttributeChange("navbarBgColor", color)
              }
            />
          </Box>
          <Box
            sx={{ width: "100%", height: "200px" }}
            component={"img"}
            src={navbarBg}
            alt="navbar-bg"
          />
        </Box>
      </Stack>
      <Stack spacing={1}>
        <Typography fontSize={"16px"} fontWeight="bold">
          Navbar dropdown
        </Typography>
        <Box
          sx={{
            border: `1px solid ${gray[300]}`,
            borderRadius: "8px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            p: 2,
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box>
              <Typography>Dropdown background Color</Typography>
              <ColorPicker
                value={getCustomisationValue(
                  "GPC",
                  "navbarSettings",
                  "navbarDropdownBgColor"
                )}
                onChange={(color) =>
                  handleAttributeChange("navbarDropdownBgColor", color)
                }
              />
            </Box>
            <Box mt={2}>
              <Typography>Dropdown text Color</Typography>
              <ColorPicker
                value={getCustomisationValue(
                  "GPC",
                  "navbarSettings",
                  "navbarDropdownTextColor"
                )}
                onChange={(color) =>
                  handleAttributeChange("navbarDropdownTextColor", color)
                }
              />
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: gray[200],
              borderRadius: "8px",
              height: 200,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img width={150} src={dropdownImage} alt="dropdown" />
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};
